import React from 'react';
import { useNavigate } from 'react-router-dom';
import FlashIcon from 'assets/images/svg/FlashIcon';

/**
 * Express orders entry point in the header - icon with the live express count on it.
 */
const UrgentExpressButton = ({ count = 0 }) => {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      className="header-icon-btn urgent-express-btn"
      title={`${count} urgent express orders`}
      onClick={() => navigate('/orders?express=true&page=1')}
    >
      <FlashIcon cssClass="header-icon" />
      {count > 0 && <span className="header-icon-badge">{count}</span>}
    </button>
  );
};

export default UrgentExpressButton;
